/**
 * PlantApi
 * 1.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "@oazapfts/runtime";
import * as QS from "@oazapfts/runtime/query";
export const defaults: Oazapfts.Defaults<Oazapfts.CustomHeaders> = {
    headers: {},
    baseUrl: "/"
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type DataStatus = "success" | "notValid" | "exception" | "error" | "inUse" | "notFound" | "noChange" | "inProgress" | "invalidPage" | "notAuthorized" | "duplicateEntity" | "noContent" | "accepted";
export type ErrorResponse = {
    message: string;
    kind: DataStatus;
    exception?: string | null;
    stackTrace?: string | null;
    exceptionType?: string | null;
    innerException?: string | null;
    validationErrors?: {
        [key: string]: string[];
    } | null;
};
export function uploadFileToBlob(facilityId: number, body?: {
    file: Blob;
}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 202;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/upload/${encodeURIComponent(facilityId)}`, oazapfts.multipart({
        ...opts,
        method: "POST",
        body
    }));
}
